import _ from 'lodash'
import store from '@/commons/store'

const filtroOrgao = function (id) {
    const orgaos = store.state.orgaos
    const orgao = _.find(orgaos, o => o.id === id)
    return orgao ? orgao.sigla : id;
}

export default filtroOrgao
